(function() {
  const container = document.getElementById('lookupResultsContainer');
  if (!container) {
    return;
  }
  initResultsPage();

  async function initResultsPage() {
    // Check if sku results are available
    const skus = getStorageData('lookupProductResults').split(',');
    if (!skus) {
      return;
    }
    
    renderPageBreadcrumbs();
    containerInnerHtml(`<div class="lookup-results__loading"><span class="spinner">Loading results...</span></div>`);

    // Get products list
    const products = await fetchAllProducts(skus);
    if (!products) {
      containerInnerHtml(`<p>There were no products found</p>`);
      return;
    }

    renderPageTitle(products.length);
    
    // Render products on the frontend
    const productList = document.createElement('ul');
    productList.classList.add('product-list', 'product-list--collection');
    products.forEach(product => {
      const li = document.createElement("li");
      li.classList.add('product-item', 'product-item--vertical', '1/3--tablet', '1/4--lap-and-up');
      li.innerHTML = generateProductCardHtml(product);
      productList.appendChild(li);
    });
    containerInnerHtml();
    container.appendChild(productList);
  }
  
  async function fetchProductBySku(sku) {
    const response = await fetch(`/search/suggest.json?q=${sku}&resources[type]=product&&resources[options][fields]=variants.sku`);
    const data = await response.json();
    const product = data.resources.results.products[0];
    if (!product) {
      return null;
    }
    const productVariantResponse = await fetch(`/products/${product.handle}.json`);
    const productVariants = await productVariantResponse.json();
    const firstAvailableVariant = productVariants.product.variants.filter((variant) => variant.sku == sku);
    if (!firstAvailableVariant) {
      return null;
    }
    return {
      id: product.id,
      variant_id: firstAvailableVariant[0].id,
      available: product.available,
      title: product.title,
      image: product.featured_image.url,
      alt: product.featured_image.alt,
      price: firstAvailableVariant[0].price,
      compare_at: firstAvailableVariant[0].compare_at_price,
      url: product.url,
      vendor: product.vendor
    };
  }

  async function fetchAllProducts(skus) {
    let products = [];
    try {
      for (const sku of skus) {
        const product = await fetchProductBySku(sku);
        if (product) {
          products.push(product);
        }
      }
    } catch (error) {
      console.error(error);
      containerInnerHtml('<p>There was an error retrieving the products list. Please try again later.</p>');
    } finally {
      if (products.length > 0) {
        return products;
      } else {
        return null;
      }
    }
  }

  function renderPageTitle(length) {
    const title = getStorageData('lookupProductTitle');
    if (!title || !document.getElementById('lookupResultsHeading')) {
      return;
    }
    const heading = document.getElementById('lookupResultsHeading');
    heading.textContent = `${length} ${length > 1 ? 'results' : 'result'} found for ${title}`;
  }

  function renderPageBreadcrumbs() {
    const title = getStorageData('lookupProductTitle');
    if (!title || !document.getElementById('lookupResultsBreadcrumbs')) {
      return;
    }
    const makeModel = title.split(" ");
    document.getElementById('lookupResultsBreadcrumbs').textContent = `Roof Rack System for ${makeModel.slice(0,2).join(" ")}`;
  }

  function generateProductCardHtml(product) {
  return `
    ${product.image ? 
      `<a href="${product.url}" class="product-item__image-wrapper">` +
        `<div class="aspect-ratio" style="padding-bottom: 100.0%">` +
          `<img src="${product.image}" alt="${product.alt}" class="product-item__primary-image">` +
        `</div>` +
      `</a>`
    : ''}
    <div class="product-item__info">
      <div class="product-item__info-inner">
        <div class="product-item__price-list price-list">
          ${product.compare_at > product.price ?
            `<span class="price price--highlight">` +
              `<span class="visually-hidden">Sale price</span>` +
              `<span class="money">£${product.price} GBP</span>` +
            `</span>` +
            `<span class="price price--compare">` +
              `<span class="visually-hidden">Regular price</span><span class="money">£${product.compare_at}</span>` +
            `</span>`
            : `<span class="price"><span class="visually-hidden">Sale price</span><span class="money">£${product.price} GBP</span></span>`
          }
        </div>
        <a href="${product.url}" class="product-item__title text--strong link">${product.title}</a>
        ${product.vendor ? 
          `<a class="product-item__vendor link" href="/collections/vendors?q=${product.vendor}">${product.vendor}</a>`
        : ''}
        <span class="product-item__inventory inventory inventory--high">${product.available ? 'In Stock' : 'Out of Stock'}</span>
      </div>
      <form action="/cart/add" method="post" class="product-item__action-list button-stack">
        <input type="hidden" name="id" value="${product.variant_id}">
        <button type="submit" class="product-item__action-button button button--small button--primary">Add to Cart</button>
        <a href=${product.url} class="product-item__action-button button button--small button--ternary hidden-phone">View Product</a>
      </form>
    </div>
  `;
}

  function containerInnerHtml(string) {
    container.innerHTML = string ? string : '';
  }

  function getStorageData(name) {
    if (!localStorage) {
      return;
    }
    const data = localStorage.getItem(name);
    return data ? JSON.parse(data) : null;
  }
}())